import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const HeroSection = () => {
  return (
    <section className="pt-16 bg-[#F7FAFC]">
      <div className="container-main">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center py-16 lg:py-24">
          {/* Content - Left */}
          <div>
            {/* Badge */}
            <div className="inline-flex items-center gap-2 bg-[#E7F2E3] rounded px-3 py-1.5 mb-6">
              <span className="w-1.5 h-1.5 bg-[#3E6B2A] rounded-full" />
              <span className="text-[#3E6B2A] text-xs font-medium">Desde 1990 • Manaus, AM</span>
            </div>

            {/* Headline */}
            <h1 className="heading-display mb-5">
              Auditoria, Consultoria e Contabilidade
            </h1>

            {/* Subheadline */}
            <p className="body-large mb-8 max-w-md">
              Há mais de três décadas, construindo relações de confiança com 
              metodologia rigorosa, integridade e excelência técnica.
            </p>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-3">
              <Link to="/contato" className="btn-primary">
                Solicitar Proposta
                <ArrowRight size={16} />
              </Link>
              <Link to="/trabalhe-conosco" className="btn-secondary">
                Trabalhe Conosco
              </Link>
            </div>

            {/* Stats - Textos neutros sem números não confirmados */}
            <div className="flex gap-8 mt-12 pt-8 border-t border-[#E2E8F0]">
              <div>
                <span className="text-2xl font-bold text-[#0F172A]">35+</span>
                <p className="text-xs text-[#64748B] mt-1">Anos de atuação</p>
              </div>
              <div>
                <span className="text-2xl font-bold text-[#0F172A]">Manaus</span>
                <p className="text-xs text-[#64748B] mt-1">Sede no Amazonas</p>
              </div>
              <div>
                <span className="text-2xl font-bold text-[#0F172A]">NBC</span>
                <p className="text-xs text-[#64748B] mt-1">& IFRS Compliance</p>
              </div>
            </div>
          </div>

          {/* Image - Right - CORPORATIVO: Consultores em reunião */}
          <div className="relative">
            <div className="aspect-[4/3] rounded-lg overflow-hidden bg-white shadow-lg border border-[#E2E8F0]">
              <img 
                src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=800&q=85" 
                alt="Consultores em reunião executiva"
                className="w-full h-full object-cover"
              />
            </div>
            {/* Floating accent */}
            <div className="absolute -bottom-4 -left-4 bg-white border border-[#E2E8F0] rounded-lg p-4 shadow-md">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-[#E7F2E3] rounded-lg flex items-center justify-center">
                  <svg className="w-5 h-5 text-[#3E6B2A]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <div>
                  <p className="text-sm font-semibold text-[#0F172A]">Metodologia</p>
                  <p className="text-xs text-[#64748B]">NBC & IFRS</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
